import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import monthSelect from '@/components/date/monthSelect';
import { getAction, httpAction } from '@api/manage';
import OperationReportModal from "./modules/OperationReportModal";
export default {
  name: 'OperationReport',
  mixins: [GetSiteIdMixin],
  components: {
    monthSelect: monthSelect,
    OperationReportModal: OperationReportModal
  },
  data: function data() {
    return {
      // pagePath: '/om/inspection/record',
      pageTitle: '运维模板',
      queryParam: {},
      url: {
        queryInspectionData: '/om/inspection/record/operation',
        queryHitchData: '/ea/asset/repair/report',
        queryStatiStics: '/om/attendance/info/statistics',
        querySiteInfo: '/ea/asset/info/queryBySiteId',
        queryWaterQuality: '/online/st21/operation/report',
        queryMonthlyReport: '/online/st21/report' // exportWord: '/inspection/report/generate/word'

      },
      siteName: '',
      siteId: '',
      quantum: '',
      timeData: [],
      inspectionColumns: [{
        dataIndex: 'formatTime',
        colName: 'formatTime',
        title: '巡检时间',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '巡检人',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '巡检类型',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'templateName',
        colName: 'template_id',
        title: '巡检模板',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'stime',
        colName: 'stime',
        title: '开始时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'etime',
        colName: 'etime',
        title: '结束时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'durationTime',
        colName: 'durationTime',
        title: '巡检时长',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'weather_dictText',
        colName: 'weather',
        title: '天气情况',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'temperature',
        colName: 'temperature',
        title: '温度（°C）',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'humidity',
        colName: 'humidity',
        title: '湿度（%RH）',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '巡检结果',
        align: 'center',
        sorter: false
      }],
      inspectionData: [],
      inspectionTotal: '',
      inspectionTotalAverage: '',
      hitchColumns: [],
      hitchData: [],
      hitchTotal: '',
      statiSticsColumns: [{
        dataIndex: 'userId_userName',
        colName: 'userId',
        title: '时间',
        align: 'center'
      }, {
        dataIndex: 'sumHour',
        colName: 'sumHour',
        title: '总时长',
        align: 'center'
      }, {
        dataIndex: 'avgHour',
        colName: 'avgHour',
        title: '平均时长',
        align: 'center'
      }, {
        dataIndex: 'countNumber',
        colName: 'countNumber',
        title: '打卡次数',
        align: 'center'
      }, {
        dataIndex: 'missCount',
        colName: 'missCount',
        title: '缺卡次数',
        align: 'center'
      }],
      statiSticsData: [],
      MonthlyColumns: [],
      infoDataList: [],
      rowspanNum: 0,
      commonList: [],
      water5: [],
      standardsList: [],
      averageValueList: [],
      MonthlyData: [],
      MonthlyQuery: []
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(ids, ids);

      if (ids[0] == 1) {
        this.siteName = this.currentSiteName;
        this.siteId = ids[1];
        this.getSiteInfo();
        this.queryAllData();
      }
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    queryAllData: function queryAllData() {
      this.getInspectionData();
      this.getColumnsData();
      this.getHitchData();
      this.getStatiSticsData();
      this.getSiteInfo();
      this.getWaterQualityData();
      this.getMonthlyReport();
    },
    // handleExportWord() {
    //     var param = { 'siteId': this.siteId, 'siteName': this.siteName, 'formatTime': this.quantum, 'year': this.timeData[0], 'month': this.timeData[1] }
    //     httpAction(this.url.exportWord, param, 'post').then((res) => {
    //         if (res) {
    //             let filename = this.quantum + this.siteName + '运维报告.doc'
    //             var blob = new Blob([res], { type: 'application/msword;charset=utf-8' })
    //             var a = document.createElement('a')
    //             var url = window.URL.createObjectURL(blob)
    //             a.href = url
    //             a.download = filename
    //             var body = document.getElementsByTagName('body')[0]
    //             body.appendChild(a)
    //             a.click()
    //             body.removeChild(a)
    //             window.URL.revokeObjectURL(url)
    //             this.$message_custom('生成word成功')
    //         } else {
    //             this.$message_custom('系统异常', 'warning')
    //         }
    //     })
    // },
    siteChange: function siteChange(data) {
      console.log(data); // debugger

      this.queryParam.scopeId = data.data.id;
      this.queryParam.scope = data.scope;
      this.$refs.modalForm.siteName = data.data.name;
      this.$refs.modalForm.siteId = data.data.id;
      this.loadData();
    },
    // 时间选择器
    // 月变化
    monthChange: function monthChange(value) {
      // this.queryParam.quantum = value
      this.quantum = value;
      console.log(this.quantum); // this.timeData = new Array()

      this.timeData = this.quantum.split('-');
      this.queryAllData();
    },
    // 查询按钮
    searchQuery: function searchQuery() {
      this.queryAllData();
    },
    searchReset: function searchReset() {
      this.queryAllData();
    },
    // 获取巡检维护统计数据
    getInspectionData: function getInspectionData() {
      var _this = this;

      this.inspectionData = [];
      var params = {
        siteId: this.siteId,
        stimeStart: this.quantum
      };
      getAction(this.url.queryInspectionData, params).then(function (res) {
        if (res.success) {
          res.result.forEach(function (item, index) {
            _this.inspectionData.push(item);

            if (item.child.length > 0) {
              _this.inspectionData[index]['children'] = item.child;
            }
          });
          _this.inspectionTotal = res.result[0] ? res.result[0].total : 0;
          _this.inspectionTotalAverage = Math.round(_this.inspectionTotal / 4);
          console.log(_this.inspectionData);
        }
      });
    },
    // 获取故障统计表头 
    getColumnsData: function getColumnsData() {
      var _this2 = this;

      getAction('/sys/dict/getDictItems/failure_cause').then(function (res) {
        if (res.success) {
          _this2.hitchColumns = [];
          res.result.forEach(function (item, index) {
            _this2.hitchColumns.push({
              dataIndex: item.value,
              colName: item.value,
              title: item.title,
              align: 'center'
            });
          });
        }
      });
    },
    // 获取故障记录数据
    getHitchData: function getHitchData() {
      var _this3 = this;

      getAction(this.url.queryHitchData + '?siteIds=' + this.siteId).then(function (res) {
        if (res.success) {
          _this3.hitchData = res.result.records.filter(function (item) {
            return item.site_id != null;
          });
          _this3.hitchTotal = res.result.records[0] ? res.result.records[0].totalCount : 0;
        }
      });
    },
    // 获取考勤数据
    getStatiSticsData: function getStatiSticsData() {
      var _this4 = this;

      var params = {
        type: 2,
        siteId: this.siteId,
        quantum: this.quantum,
        queryStatus: 0
      };
      getAction(this.url.queryStatiStics, params).then(function (res) {
        if (res.success) {
          _this4.statiSticsData = res.result;
        }
      });
    },
    // 获取水质情况汇总表
    getWaterQualityData: function getWaterQualityData() {
      var _this5 = this;

      var params = {
        type: 3,
        scopeId: this.siteId,
        quantum: this.quantum,
        column: 'data_time',
        order: 'asc',
        st: 21,
        scope: 1
      };
      this.commonList = [];
      getAction(this.url.queryWaterQuality, params).then(function (res) {
        if (res) {
          _this5.commonList = res.common;
          _this5.water5 = res.water5;
          var arr = [];
          res.standards.forEach(function (item) {
            var arr1 = [];

            _this5.commonList.forEach(function (item1, index1) {
              if (!item[item1.factor.code]) {
                item[item1.factor.code] = {};
                item[item1.factor.code]['zsavg'] = item1.zsavg;
              }

              arr1.push(item[item1.factor.code]);
            });

            arr.push(arr1);
          });
          _this5.standardsList = arr;
        }
      });
    },
    // 获取站点基本情况
    getSiteInfo: function getSiteInfo() {
      var _this6 = this;

      getAction(this.url.querySiteInfo + '/' + this.siteId).then(function (res) {
        if (res.success) {
          _this6.infoDataList = res.result;
          _this6.rowspanNum = _this6.infoDataList.length + 1;
          console.log(_this6.infoDataList);

          _this6.$forceUpdate();
        }
      });
    },
    // 获取月报表
    getMonthlyReport: function getMonthlyReport() {
      var _this7 = this;

      var params = {
        type: 3,
        scopeId: this.siteId,
        quantum: this.quantum,
        column: 'data_time',
        order: 'asc',
        st: 21,
        scope: 1
      };
      getAction(this.url.queryMonthlyReport, params).then(function (res) {
        if (res.success) {
          _this7.MonthlyQuery = res.result.query;
          var columns = [{
            dataIndex: 'dataTime',
            colName: 'dataTime',
            title: '时间',
            align: 'center'
          }];
          res.result.query.factors.forEach(function (item) {
            columns.push({
              dataIndex: item.code,
              colName: item.code,
              title: item.title + '(' + item.unitName + ')',
              align: 'center'
            });
          });
          columns.push({
            dataIndex: 'title',
            colName: 'title',
            title: '环境标准',
            align: 'center'
          });
          _this7.MonthlyColumns = columns;
          _this7.MonthlyData = [];
          res.result.records.forEach(function (item1) {
            var arr3 = {};
            var arr4 = {};

            if (Object.keys(item1.factor).length !== 0) {
              for (var key1 in item1.factor) {
                if (item1.factor[key1]) {
                  arr3[key1] = item1.factor[key1].value;
                  arr3['dataTime'] = item1.dataTime;
                  arr3['title'] = item1.attrs.currentStandard ? item1.attrs.currentStandard.title : '-';

                  if (item1.dataTime === '平均值') {
                    arr4[key1] = item1.factor[key1].standard ? item1.factor[key1].standard.title : '-';
                    arr4['dataTime'] = '水质类别';
                    arr4['title'] = item1.attrs.currentStandard ? item1.attrs.currentStandard.title : '-';
                  }
                }
              }
            }

            if (Object.keys(arr3).length !== 0 && arr3.dataTime !== '最大值' && arr3.dataTime !== '最小值') {
              _this7.MonthlyData.push(arr3);

              if (item1.dataTime === '平均值') {
                _this7.MonthlyData.push(arr4);
              }
            }
          });
        }
      });
    },
    openModal: function openModal() {
      this.$refs.operationReportModal.visible = true;
    }
  }
};